"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = enhanceForm;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _get = _interopRequireDefault(require("lodash/get"));

var _set = _interopRequireDefault(require("lodash/set"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _defaultsDeep = _interopRequireDefault(require("lodash/defaultsDeep"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _validationWrapper = _interopRequireDefault(require("./validation-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function setIn(object, key, value) {
  var result = (0, _cloneDeep.default)(object);
  (0, _set.default)(result, key, value);
  return result;
}

function enhanceForm(Form) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(EnhancedForm, _React$Component);

    function EnhancedForm(props) {
      var _this;

      _classCallCheck(this, EnhancedForm);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(EnhancedForm).call(this, props));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onSubmitListeners", {});

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        values: {},
        errors: {},
        onSubmitListeners: {}
      });

      _this.onChangeField = _this.onChangeField.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.subscribeToOnSubmit = _this.subscribeToOnSubmit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.unsubscribeToOnSubmit = _this.unsubscribeToOnSubmit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.resetValues = _this.resetValues.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    _createClass(EnhancedForm, [{
      key: "getChildContext",
      value: function getChildContext() {
        var name = this.props.name;
        var errors = this.state.errors;
        var onChangeField = this.onChangeField;
        var subscribeToOnSubmit = this.subscribeToOnSubmit;
        var unsubscribeToOnSubmit = this.unsubscribeToOnSubmit;
        return name != null ? {
          form: {
            values: this._getValues(),
            errors: errors,
            onChangeField: onChangeField,
            subscribeToOnSubmit: subscribeToOnSubmit,
            unsubscribeToOnSubmit: unsubscribeToOnSubmit
          }
        } : {
          form: {}
        };
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {}
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {}
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var _this$props = this.props,
            resetWhenDefaultsChange = _this$props.resetWhenDefaultsChange,
            currentDefaults = _this$props.defaultValues;
        var nextDefaults = nextProps.defaultValues;

        if (resetWhenDefaultsChange && !(0, _isEqual.default)(nextDefaults, currentDefaults)) {
          this.setState({
            values: {},
            errors: {}
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var name = this.props.name;

        if (name == null) {
          return _react.default.createElement(Form, _objectSpread({}, this.props));
        }

        return _react.default.createElement(Form, _objectSpread({}, (0, _omit.default)(this.props, ['defaultValues', 'resetWhenDefaultsChange']), {
          onSubmit: this.onSubmit
        }));
      }
    }, {
      key: "onChangeField",
      value: function onChangeField(value, name) {
        var values = this.state.values;
        this.setState({
          values: setIn(values, name, value)
        });
      }
    }, {
      key: "subscribeToOnSubmit",
      value: function subscribeToOnSubmit(name, listener) {
        var onSubmitListeners = this.state.onSubmitListeners;
        this.onSubmitListeners = _objectSpread({}, this.onSubmitListeners, _defineProperty({}, name, listener));
      }
    }, {
      key: "unsubscribeToOnSubmit",
      value: function unsubscribeToOnSubmit(name) {
        var onSubmitListeners = this.state.onSubmitListeners;
        this.onSubmitListeners = (0, _omit.default)(this.onSubmitListeners, [name]);
      }
    }, {
      key: "onSubmit",
      value: function onSubmit(e) {
        var onSubmit = this.props.onSubmit;

        var errors = this._runOnSubmitListeners();

        if (!errors) {
          return onSubmit(this._getValues(), this.resetValues, e);
        }
      }
    }, {
      key: "resetValues",
      value: function resetValues() {
        this.setState({
          values: {},
          errors: {}
        });
      }
    }, {
      key: "_getValues",
      value: function _getValues() {
        var values = this.state.values;
        var defaultValues = this.props.defaultValues;
        return (0, _defaultsDeep.default)({}, values, defaultValues);
      }
    }, {
      key: "_runOnSubmitListeners",
      value: function _runOnSubmitListeners() {
        var _this2 = this;

        var onSubmitListeners = this.onSubmitListeners;
        var hasErrors = false;
        var errors = {};
        Object.keys(onSubmitListeners).map(function (name) {
          var listener = onSubmitListeners[name];
          var value = (0, _get.default)(_this2._getValues(), name);
          var result = listener(new _validationWrapper.default(value), _this2._getValues());

          if (result.errorMessage) {
            (0, _set.default)(errors, name, result.errorMessage);
            hasErrors = true;
          }
        });
        this.setState({
          errors: errors
        });
        return hasErrors;
      }
    }]);

    return EnhancedForm;
  }(_react.default.Component), _defineProperty(_class, "childContextTypes", {
    form: _propTypes.default.shape({
      values: _propTypes.default.object,
      errors: _propTypes.default.object,
      onChangeField: _propTypes.default.func,
      subscribeToOnSubmit: _propTypes.default.func,
      unsubscribeToOnSubmit: _propTypes.default.func
    })
  }), _temp;
}